export default {
  d8: [
    { first: '- 0,020', second: '- 0,034' },
    { first: '- 0,030', second: '- 0,048' },
    { first: '- 0,040', second: '- 0,062' },
    { first: '- 0,050', second: '- 0,077' },
    { first: '-0,065', second: '-0,098' },
    { first: '-0,080', second: '-0,119' },
    { first: '-0,100', second: '-0,146' },
    { first: '-0,120', second: '-0,174' },
    { first: '-0,145', second: '-0,208' },
    { first: '-0,170', second: '-0,242' },
  ],
  d9: [
    { first: '- 0,020', second: '- 0,045' },
    { first: '- 0,030', second: '- 0,060' },
    { first: '- 0,040', second: '- 0,076' },
    { first: '- 0,050', second: '- 0,093' },
    { first: '-0,065', second: '-0,117' },
    { first: '-0,080', second: '-0,142' },
    { first: '-0,100', second: '-0,174' },
    { first: '-0,120', second: '-0,207' },
    { first: '-0,145', second: '-0,245' },
    { first: '-0,170', second: '-0,285' },
  ],
  d10: [
    { first: '- 0,020', second: '- 0,060' },
    { first: '- 0,030', second: '- 0,078' },
    { first: '- 0,040', second: '- 0,098' },
    { first: '- 0,050', second: '- 0,120' },
    { first: '-0,065', second: '-0,149' },
    { first: '-0,080', second: '-0,180' },
    { first: '-0,100', second: '-0,220' },
    { first: '-0,120', second: '-0,260' },
    { first: '-0,145', second: '-0,305' },
    { first: '-0,170', second: '-0,355' },
  ],
  e6: [
    { first: '- 0,014', second: '- 0,020' },
    { first: '- 0,020', second: '- 0,028' },
    { first: '- 0,025', second: '- 0,034' },
    { first: '- 0,032', second: '- 0,043' },
    { first: '-0,040', second: '-0,053' },
    { first: '-0,050', second: '-0,066' },
    { first: '-0,060', second: '-0,079' },
    { first: '-0,072', second: '-0,094' },
    { first: '-0,085', second: '-0,110' },
    { first: '-0,100', second: '-0,129' },
  ],
  e7: [
    { first: '- 0,014', second: '- 0,024' },
    { first: '- 0,020', second: '- 0,032' },
    { first: '- 0,025', second: '- 0,040' },
    { first: '- 0,032', second: '- 0,050' },
    { first: '-0,040', second: '-0,061' },
    { first: '-0,050', second: '-0,075' },
    { first: '-0,060', second: '-0,090' },
    { first: '-0,072', second: '-0,107' },
    { first: '-0,085', second: '-0,125' },
    { first: '-0,100', second: '-0,146' },
  ],
  e8: [
    { first: '- 0,014', second: '- 0,028' },
    { first: '- 0,020', second: '- 0,038' },
    { first: '- 0,025', second: '- 0,047' },
    { first: '- 0,032', second: '- 0,059' },
    { first: '-0,040', second: '-0,073' },
    { first: '-0,050', second: '-0,089' },
    { first: '-0,060', second: '-0,106' },
    { first: '-0,072', second: '-0,126' },
    { first: '-0,085', second: '-0,148' },
    { first: '-0,100', second: '-0,172' },
  ],
  e9: [
    { first: '- 0,014', second: '- 0,039' },
    { first: '- 0,020', second: '- 0,050' },
    { first: '- 0,025', second: '- 0,061' },
    { first: '- 0,032', second: '- 0,075' },
    { first: '-0,040', second: '-0,092' },
    { first: '-0,050', second: '-0,112' },
    { first: '-0,060', second: '-0,134' },
    { first: '-0,072', second: '-0,159' },
    { first: '-0,085', second: '-0,185' },
    { first: '-0,100', second: '-0,215' },
  ],
  f6: [
    { first: '- 0,006', second: '- 0,012' },
    { first: '- 0,010', second: '- 0,018' },
    { first: '- 0,013', second: '- 0,022' },
    { first: '- 0,016', second: '- 0,027' },
    { first: '-0,020', second: '-0,033' },
    { first: '-0,025', second: '-0,041' },
    { first: '-0,030', second: '-0,049' },
    { first: '-0,036', second: '-0,058' },
    { first: '-0,043', second: '-0,068' },
    { first: '-0,050', second: '-0,079' },
  ],
  f7: [
    { first: '- 0,006', second: '- 0,016' },
    { first: '- 0,010', second: '- 0,022' },
    { first: '- 0,013', second: '- 0,028' },
    { first: '- 0,016', second: '- 0,034' },
    { first: '-0,020', second: '-0,041' },
    { first: '-0,025', second: '-0,050' },
    { first: '-0,03', second: '-0,06' },
    { first: '-0,036', second: '-0,071' },
    { first: '-0,043', second: '-0,083' },
    { first: '-0,05', second: '-0,096' },
  ],
  f8: [
    { first: '- 0,006', second: '- 0,020' },
    { first: '-0,01', second: '-0,028' },
    { first: '-0,013', second: '-0,035' },
    { first: '-0,016', second: '-0,043' },
    { first: '-0,02', second: '-0,053' },
    { first: '-0,025', second: '-0,064' },
    { first: '-0,03', second: '-0,076' },
    { first: '-0,036', second: '-0,09' },
    { first: '-0,043', second: '-0,106' },
    { first: '-0,05', second: '-0,122' },
  ],
  g6: [
    { first: '- 0,002', second: '- 0,008' },
    { first: '-0,004', second: '-0,012' },
    { first: '-0,005', second: '-0,014' },
    { first: '-0,006', second: '-0,017' },
    { first: '-0,007', second: '-0,02' },
    { first: '-0,009', second: '-0,025' },
    { first: '-0,01', second: '-0,029' },
    { first: '-0,012', second: '-0,034' },
    { first: '-0,014', second: '-0,039' },
    { first: '-0,015', second: '-0,044' },
  ],
  h5: [
    { first: '0,000', second: '- 0,004' },
    { first: '0,000', second: '- 0,005' },
    { first: '0,000', second: '- 0,006' },
    { first: '0,000', second: '-0,008' },
    { first: '0,000', second: '-0,009' },
    { first: '0,000', second: '-0,011' },
    { first: '0,000', second: '-0,013' },
    { first: '0,000', second: '-0,015' },
    { first: '0,000', second: '-0,018' },
    { first: '0,000', second: '-0,02' },
  ],
  h6: [
    { first: '0,000', second: '- 0,006' },
    { first: '0,000', second: '- 0,008' },
    { first: '0,000', second: '- 0,009' },
    { first: '0,000', second: '-0,011' },
    { first: '0,000', second: '-0,013' },
    { first: '0,000', second: '-0,016' },
    { first: '0,000', second: '-0,019' },
    { first: '0,000', second: '-0,022' },
    { first: '0,000', second: '-0,025' },
    { first: '0,000', second: '-0,029' },
  ],
  h7: [
    { first: '0,000', second: '- 0,010' },
    { first: '0,000', second: '- 0,012' },
    { first: '0,000', second: '- 0,015' },
    { first: '0,000', second: '-0,018' },
    { first: '0,000', second: '-0,021' },
    { first: '0,000', second: '-0,025' },
    { first: '0,000', second: '-0,03' },
    { first: '0,000', second: '-0,035' },
    { first: '0,000', second: '-0,04' },
    { first: '0,000', second: '-0,046' },
  ],
  h8: [
    { first: '0,000', second: '- 0,014' },
    { first: '0,000', second: '- 0,018' },
    { first: '0,000', second: '- 0,022' },
    { first: '0,000', second: '-0,024' },
    { first: '0,000', second: '-0,033' },
    { first: '0,000', second: '-0,039' },
    { first: '0,000', second: '-0,046' },
    { first: '0,000', second: '-0,054' },
    { first: '0,000', second: '-0,063' },
    { first: '0,000', second: '-0,072' },
  ],
  h9: [
    { first: '0,000', second: '- 0,025' },
    { first: '0,000', second: '- 0,03' },
    { first: '0,000', second: '- 0,036' },
    { first: '0,000', second: '-0,043' },
    { first: '0,000', second: '-0,052' },
    { first: '0,000', second: '-0,062' },
    { first: '0,000', second: '-0,074' },
    { first: '0,000', second: '-0,087' },
    { first: '0,000', second: '-0,1' },
    { first: '0,000', second: '-0,015' },
  ],
  h10: [
    { first: '0,000', second: '- 0,04' },
    { first: '0,000', second: '- 0,048' },
    { first: '0,000', second: '- 0,058' },
    { first: '0,000', second: '-0,07' },
    { first: '0,000', second: '-0,084' },
    { first: '0,000', second: '-0,1' },
    { first: '0,000', second: '-0,12' },
    { first: '0,000', second: '-0,14' },
    { first: '0,000', second: '-0,16' },
    { first: '0,000', second: '-0,185' },
  ],
  j5: [
    { first: '+0,002', second: '- 0,002' },
    { first: '+0,003', second: '- 0,002' },
    { first: '+0,004', second: '- 0,002' },
    { first: '0,005', second: '-0,003' },
    { first: '0,005', second: '0,004-' },
    { first: '0,006', second: '-0,005' },
    { first: '0,006', second: '-0,007' },
    { first: '0,006', second: '-0,009' },
    { first: '0,007', second: '-0,011' },
    { first: '0,007', second: '-0,013' },
  ],
  j6: [
    { first: '+0,004', second: '- 0,002' },
    { first: '+0,006', second: '- 0,002' },
    { first: '+0,007', second: '- 0,002' },
    { first: '0,008', second: '-0,003' },
    { first: '0,009', second: '-0,004' },
    { first: '0,011', second: '-0,005' },
    { first: '0,012', second: '-0,007' },
    { first: '0,013', second: '-0,009' },
    { first: '0,014', second: '-0,011' },
    { first: '0,016', second: '-0,013' },
  ],
  j7: [
    { first: '+0,006', second: '- 0,004' },
    { first: '+0,008', second: '- 0,004' },
    { first: '+0,010', second: '- 0,005' },
    { first: '0,012', second: '-0,006' },
    { first: '0,013', second: '-0,008' },
    { first: '0,015', second: '-0,01' },
    { first: '0,018', second: '-0,012' },
    { first: '0,02', second: '-0,015' },
    { first: '0,022', second: '-0,018' },
    { first: '0,025', second: '-0,021' },
  ],
  j8: [
    { first: '+0,007', second: '- 0,007' },
    { first: '+0,009', second: '- 0,009' },
    { first: '+0,011', second: '- 0,011' },
    { first: '0,014', second: '-0,013' },
    { first: '0,017', second: '-0,016' },
    { first: '0,02', second: '-0,019' },
    { first: '0,023', second: '-0,023' },
    { first: '0,027', second: '-0,027' },
    { first: '0,032', second: '-0,031' },
    { first: '0,036', second: '-0,036' },
  ],
  k5: [
    { first: '+0,004', second: '0,000' },
    { first: '+0,006', second: '+0,001' },
    { first: '+0,007', second: '+0,001' },
    { first: '0,009', second: '0,001' },
    { first: '0,011', second: '0,002' },
    { first: '0,013', second: '0,002' },
    { first: '0,015', second: '0,002' },
    { first: '0,018', second: '0,003' },
    { first: '0,021', second: '0,003' },
    { first: '0,024', second: '0,004' },
  ],
  k6: [
    { first: '+0,006', second: '' },
    { first: '+0,009', second: '+0,001' },
    { first: '+0,010', second: '+0,001' },
    { first: '0,012', second: '0,001' },
    { first: '0,015', second: '0,002' },
    { first: '0,018', second: '0,002' },
    { first: '0,021', second: '0,002' },
    { first: '0,025', second: '0,003' },
    { first: '0,028', second: '0,003' },
    { first: '0,033', second: '0,004' },
  ],
  m6: [
    { first: '', second: '' },
    { first: '+0,012', second: '+0,004' },
    { first: '+0,015', second: '+0,006' },
    { first: '0,018', second: '0,007' },
    { first: '0,021', second: '0,008' },
    { first: '0,025', second: '0,009' },
    { first: '0,03', second: '0,011' },
    { first: '0,035', second: '0,013' },
    { first: '0,04', second: '0,015' },
    { first: '0,046', second: '0,017' },
  ],
  m7: [
    { first: '', second: '' },
    { first: '+0,016', second: '+0,004' },
    { first: '+0,021', second: '+0,006' },
    { first: '0,025', second: '0,007' },
    { first: '0,029', second: '0,008' },
    { first: '0,034', second: '0,009' },
    { first: '0,041', second: '0,011' },
    { first: '0,048', second: '0,013' },
    { first: '0,055', second: '0,015' },
    { first: '0,063', second: '0,017' },
  ],
  n6: [
    { first: '+0,010', second: '+0,004' },
    { first: '+0,016', second: '+0,008' },
    { first: '+0,019', second: '+0,010' },
    { first: '0,023', second: '0,012' },
    { first: '0,028', second: '0,015' },
    { first: '0,033', second: '0,017' },
    { first: '0,039', second: '0,02' },
    { first: '0,045', second: '0,023' },
    { first: '0,052', second: '0,027' },
    { first: '0,06', second: '0,031' },
  ],
  n7: [
    { first: '', second: '' },
    { first: '+0,020', second: '+0,008' },
    { first: '+0,025', second: '+0,010' },
    { first: '0,03', second: '0,012' },
    { first: '0,036', second: '0,015' },
    { first: '0,042', second: '0,017' },
    { first: '0,05', second: '0,02' },
    { first: '0,058', second: '0,023' },
    { first: '0,067', second: '0,027' },
    { first: '0,077', second: '0,031' },
  ],
  p6: [
    { first: '+0,012', second: '+0,006' },
    { first: '+0,020', second: '+0,012' },
    { first: '+0,024', second: '+0,015' },
    { first: '0,029', second: '0,018' },
    { first: '0,035', second: '0,022' },
    { first: '0,042', second: '0,026' },
    { first: '0,051', second: '0,032' },
    { first: '0,059', second: '0,037' },
    { first: '0,068', second: '0,043' },
    { first: '0,079', second: '0,05' },
  ],
  p7: [
    { first: '+0,016', second: '+0,006' },
    { first: '+0,024', second: '+0,012' },
    { first: '+0,030', second: '+0,015' },
    { first: '0,036', second: '0,018' },
    { first: '0,043', second: '0,022' },
    { first: '0,051', second: '0,026' },
    { first: '0,062', second: '0,032' },
    { first: '0,072', second: '0,037' },
    { first: '0,083', second: '0,043' },
    { first: '0,096', second: '0,05' },
  ],
  r6: [
    { first: '+0,016', second: '+0,010' },
    { first: '+0,023', second: '+0,015' },
    { first: '+0,028', second: '+0,019' },
    { first: '0,034', second: '0,023' },
    { first: '0,041', second: '0,028' },
    { first: '0,05', second: '0,034' },
    { first: '0,062', second: '0,041' },
    { first: '0,076', second: '0,051' },
    { first: '0,093', second: '0,063' },
    { first: '0,113', second: '0,077' },
  ],
  s6: [
    { first: '+0,020', second: '+0,014' },
    { first: '+0,027', second: '+0,019' },
    { first: '+0,032', second: '+0,023' },
    { first: '0,039', second: '0,028' },
    { first: '0,048', second: '0,035' },
    { first: '0,059', second: '0,043' },
    { first: '0,078', second: '0,053' },
    { first: '0,101', second: '0,071' },
    { first: '0,133', second: '0,092' },
    { first: '0,169', second: '0,122' },
  ],
  s7: [
    { first: '+0,024', second: '+0,014' },
    { first: '+0,031', second: '+0,019' },
    { first: '+0,038', second: '+0,023' },
    { first: '0,046', second: '0,028' },
    { first: '0,056', second: '0,035' },
    { first: '0,068', second: '0,043' },
    { first: '0,089', second: '0,053' },
    { first: '', second: '0,071' },
    { first: '0,148', second: '0,092' },
    { first: '0,186', second: '0,122' },
  ],
};
